module.exports = __webpack_public_path__ + "img/yc-line-3-4.svg";